import { Controller } from "@hotwired/stimulus";
import Quill from "quill";
import QuillMarkdown from "quilljs-markdown";
import QuillAutoLink from "../lib/quill_auto_link";

export default class extends Controller {

  static targets = ['container', 'input'];

  static values = {
    inline: Boolean
  }

  connect() {
    Quill.register('modules/QuillMarkdown', QuillMarkdown, true);
    Quill.register('modules/autoLink', QuillAutoLink, true);
    const quill = new Quill(this.containerTarget, {
      modules: {
        toolbar: false,
        QuillMarkdown: {},
        autoLink: {},
      },
      readOnly: false,
      theme: 'snow',
      formats: this.buildFormats()
    });

    const input = this.inputTarget;

    if (input.value !== null && input.value !== undefined && input.value !== '') {
      quill.clipboard.dangerouslyPasteHTML(input.value);
    }

    quill.on('text-change', (delta, oldDelta, source) => {
      if (quill.getText().trim().length === 0) {
        input.value = '';
      } else {
        input.value = quill.getSemanticHTML()
          .replaceAll('<p></p>', '<p><br/></p>')
          .replaceAll('&nbsp;', ' ');
      }
    });

    this.quillObject = quill;
  }

  buildFormats() {
    if (this.inlineValue) {
      return [
        'bold',
        'italic',
        'list',
        'link'
      ]
    } else {
      return [
        'bold',
        'italic',
        'list',
        'link',
        'header'
      ]
    }
  }

  handleChange(event) {
    this.quillObject.root.innerHTML = event.detail.content;
  }

}